import React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { BootstrapDialog } from "./ConfirmModal.styles";
import { useSelector } from "react-redux";
import { useConfirmModal } from "./useConfirmModal";

const ConfirmModal = () => {
  const { open, message, title } = useSelector((state) => state.confirmModal);
  const { handleConfirm, handleClose } = useConfirmModal();

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Cancel
        </Button>
        <Button
          autoFocus
          onClick={handleConfirm}
          variant="contained"
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ConfirmModal;
